import styled from "styled-components";

export const StyledTitle = styled.h2`
  margin-bottom: 1.2rem;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 700;
  line-height: 3.66rem;
  letter-spacing: -0.024rem;
  color: ${({ theme }) => theme.fontColor};
`;
